import { render } from "./investment-data.vue?vue&type=template&id=5c92f696&scoped=true"
import script from "./investment-data.vue?vue&type=script&lang=js"
export * from "./investment-data.vue?vue&type=script&lang=js"

import "./investment-data.vue?vue&type=style&index=0&id=5c92f696&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5c92f696"

export default script